export const server = "https://bytemert-tech-shop.onrender.com/api/v2";

export const backend_url = "https://bytemert-tech-shop.onrender.com"; 
